<template>
  <hm-content title="">
    <div class="">
      <el-radio-group v-model="auditState" size="small" @change="switchTabs">
        <el-radio-button label="guider">导购提现</el-radio-button>
        <el-radio-button label="shop">门店提现</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table-panel flex flex-end" v-if="auditState === 'guider'">
      <el-input
        clearable
        v-model.trim="searchCondition.keyWord"
        placeholder="输入提现单号/会员姓名/电话号码"
        size="small"
        style="width: 222px"
        class="ipt mr10"
      ></el-input>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="daterange"
        align="right"
        start-placeholder="申请开始日期"
        end-placeholder="申请结束日期"
        value-format="yyyy-MM-dd"
        size="small"
        class="mr10"
      ></el-date-picker>
      <el-select
        size="small"
        clearable
        placeholder="选择状态"
        v-model="searchCondition.auditState"
        class="mr10"
        style="width: 200px"
        filterable
      >
        <el-option
          v-for="(item, i) in statusList"
          :key="i"
          :label="item.name"
          :value="item.objectId"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output('queryAllList', '导购提现')"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table" v-if="auditState === 'guider'">
      <el-table
        stripe
        border
        ref="brandTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="状态"
        >
          <template slot-scope="scope">
            <span
              class="status success"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'agree'"
              >通过</span
            >
            <span
              class="status blue"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'wait'"
              >待审核</span
            >
            <span
              class="status danger"
              :class="scope.row.status"
              v-show="scope.row.auditState === 'refuse'"
              >驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashSn"
          label="提现单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPhone"
          label="电话号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="idcard"
          label="身份证号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcachApplyTime"
          label="申请时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashMoney"
          label="申请金额"
        >
          <template slot-scope="scope">
            <div class="primary">¥{{ scope.row.getcashMoney }}</div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="refuseReason"
          label="驳回备注"
          width="200"
          :show-overflow-tooltip="true"
        >
          <!-- <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.refuseReason"
                    placement="top"
                  >
                  <div>
                     {{ scope.row.refuseReason }}
                  </div>

                  </el-tooltip>
                </template> -->
        </el-table-column>
        <!-- 已审核已驳回不显示 -->
        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="bill(scope.row)"
                >个人账单</el-button
              >
              <el-button
                size="small"
                type="text"
                class="blue"
                @click="audit(scope.row)"
                v-if="scope.row.auditState === 'wait'"
                >同意</el-button
              >
              <el-button
                size="small"
                type="text"
                class="danger"
                v-if="scope.row.auditState === 'wait'"
                @click="reject(scope.row)"
                >驳回</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="table-panel flex flex-between mt10"
      v-if="auditState === 'shop'"
    >
      <div>
        <el-button size="small" type="primary" @click="toAdd"
          >提现申请</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.keyword"
          placeholder="输入姓名/电话"
          size="small"
          style="width: 222px"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="daterange"
          align="right"
          start-placeholder="申请开始日期"
          end-placeholder="申请结束日期"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.minGetcashCommission"
          placeholder="可提现下限"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.maxGetcashCommission"
          placeholder="可提现上限"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          clearable
          placeholder="选择状态"
          v-model="searchCondition.auditState"
          class="mr10"
          style="width: 200px"
          filterable
        >
          <el-option
            v-for="(item, i) in statusList"
            :key="i"
            :label="item.name"
            :value="item.objectId"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '导购提现')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table" v-if="auditState === 'shop'">
      <el-table
        stripe
        border
        ref="brandTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashApprovalState"
          label="提现单状态"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.getcashApprovalState === 'apply'"
              class="success"
              >已申请</span
            >
            <span
              v-if="scope.row.getcashApprovalState === 'agree'"
              class="success"
              >已同意</span
            >
            <span
              v-if="scope.row.getcashApprovalState === 'pay'"
              class="success"
              >已转账</span
            >
            <span
              v-if="scope.row.getcashApprovalState === 'refuse'"
              class="danger"
              >已拒绝</span
            >
            <!-- <span
              v-if="scope.row.getcashApprovalState === 'confirmed'"
              class="success"
              >已确认</span
            > -->
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="电话"
        >
        </el-table-column>
        <el-table-column
          prop="receiveAccount"
          header-align="center"
          align="center"
          label="收款账户"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.receiveMode === 'alipay'"
              >支付宝:{{ scope.row.receiveAccount }}</span
            >
            <span v-if="scope.row.receiveMode === 'wxpay'"
              >微信:{{ scope.row.receiveAccount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="allowGetcashMoneyAmount"
          label="可提现佣金"
        >
          <template slot-scope="scope" v-if="scope.row.allowGetcashMoneyAmount">
            <span>¥{{ scope.row.allowGetcashMoneyAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashCommission"
          label="申请金额"
        >
          <template slot-scope="scope">
            <span>¥{{ scope.row.getcashCommission }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashTime"
          label="申请日期"
        >
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="转账" placement="top">
                <button
                  :disabled="scope.row.getcashApprovalState !== 'agree'"
                  class="pointer mr10 no-bg"
                  @click="payment(scope.row)"
                >
                  <span
                    class="hmicon icon-fukuan "
                    :class="
                      scope.row.getcashApprovalState === 'agree'
                        ? 'success'
                        : 'gray'
                    "
                  ></span>
                </button>
              </el-tooltip>

              <el-tooltip class="item" content="同意" placement="top">
                <button
                  :disabled="scope.row.getcashApprovalState !== 'apply'"
                  class="pointer mr10 no-bg"
                  @click="consent(scope.row)"
                >
                  <span
                    class="hmicon icon-tongyi "
                    :class="
                      scope.row.getcashApprovalState === 'apply'
                        ? 'blue'
                        : 'gray'
                    "
                  ></span>
                </button>
              </el-tooltip>

              <el-tooltip class="item" content="拒绝" placement="top">
                <button
                  :disabled="scope.row.getcashApprovalState !== 'apply'"
                  class="pointer mr10 no-bg"
                  @click="reject(scope.row)"
                >
                  <span
                    class="hmicon icon-jujue "
                    :class="
                      scope.row.getcashApprovalState === 'apply'
                        ? 'primary'
                        : 'gray'
                    "
                  ></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="75%"
    >
      <div class="modal-table mb20 mt10" v-if="type === 'daoGou'">
        <el-table stripe :data="[row]" size="small">
          <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberPhone"
            label="电话"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard"
            label="身份证号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="所属商户"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="所属门店"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="allowGetcashMoneyAmount"
            label="可提现"
          >
            <template slot-scope="scope">
              {{ scope.row.allowGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="beingGetcashMoneyAmount"
            label="待发放"
          >
            <template slot-scope="scope">
              {{ scope.row.beingGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="hasGetcashMoneyAmount"
            label="已提现"
          >
            <template slot-scope="scope">
              {{ scope.row.hasGetcashMoneyAmount }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="type === 'daoGou'">
        <div class="table-panel flex flex-end" v-if="currentRow.guiderId">
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="declareTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择上传时间段"
              end-placeholder="选择上传时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryGuiderOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllGuiderOrderList', '导购账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
          </div>
        </div>
        <div class="table" v-if="currentRow.guiderId">
          <el-table stripe border :data="guiderList" size="small">
            <el-table-column
              header-align="center"
              align="center"
              prop="declareSn"
              label="申报单号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="小票号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="declareTime"
              label="申报时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptTime"
              label="小票日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="销售商品数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.goodsNum }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="details(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="guiderListTotal"
              @current-change="guiderPaging"
              @size-change="handleGuiderSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="guiderCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="mt10 danger">
          还不是导购!
        </div>
      </div>
      <div v-if="type === 'shop'">
        <div class="mb10 flex flex-wrap">
          <div
            class="agent mr10 flex item-center flex-end"
            style="width:80px;height:32px"
          >
            查找提现人
          </div>

          <div>
            <el-input
              clearable
              style="width:300px"
              v-model.trim="keyWord"
              :placeholder="placeholder"
              size="small"
              class="ipt mr10"
            >
              <el-select
                slot="prepend"
                size="small"
                style="width:100px"
                @change="selectQueryType"
                v-model="queryType"
              >
                <el-option label="手机号" value="memberMobile"></el-option>
                <el-option label="会员名称" value="memberName"></el-option>
              </el-select>
            </el-input>

            <el-button type="primary" size="small" @click="searchMember"
              >查询</el-button
            >

            <div
              class="member-body flex flex-wrap item-center"
              v-for="(v, i) in memberInfo"
              :key="i"
            >
              <div class="agent flex-1">{{ v.memberName }}</div>
              <div class="agent flex-1 ">{{ v.memberMobile }}</div>
              <el-button
                type="text"
                size="small"
                class="blue flex-1"
                @click="confirmAdd(v)"
                >确认添加</el-button
              >
            </div>
          </div>
        </div>

        <div>
          <div class="table">
            <el-table
              stripe
              border
              :data="addAgentList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="agentName"
                label="会员名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="agentPhone"
                label="会员电话"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="agentTitleId"
                label="所属商铺"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="actualRewardRatio"
                label="门店"
              >
              </el-table-column>

              <el-table-column
                prop="parentRewardRatio"
                header-align="center"
                align="center"
                width="200"
                label="提现金额"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-input
                      v-model="scope.row.parentRewardRatio"
                      @input="
                        filterGt0OrFixed222('parentRewardRatio', scope.$index)
                      "
                      clearable
                      style="width:130px;"
                      placeholder="请输入提现金额"
                      size="small"
                      class="ipt mr10"
                    ></el-input>
                    <div class="flex flex-center item-center">%</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      class="blue"
                      type="text"
                      @click="remove(scope.$index)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button @click="save" size="small" type="primary">
            确 认</el-button
          >
          <el-button size="small" @click="handleClose">取 消</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      title="驳回备注"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleRefuse"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="refuseReason">
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.refuseReason"
          ></el-input>
        </el-form-item>
        <!-- <div class="reject-reason">
          <el-radio-group v-model="rejectReason" @change="switchRejectReason">
            <div v-for="(v, i) in rejectTemp" :key="i">
              <el-radio :label="i">{{ v }}</el-radio>
            </div>
          </el-radio-group>
        </div> -->
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      keyWord: "",
      placeholder: "请输入手机号",
      queryType: "memberMobile",
      addAgentList: [],
      memberInfo: [],
      type: "",
      title: "",
      isOutputing: false,
      searchCondition: {},
      currentPage: 1,
      pageSize: 10,
      list: [{ auditState: "wait", getcashApprovalState: "apply" }],
      total: 0,
      auditState: "guider",
      statusList: [
        {
          name: "通过",
          objectId: "agree"
        },
        {
          name: "驳回",
          objectId: "refuse"
        },
        {
          name: "待审核",
          objectId: "wait"
        }
      ],
      row: {},
      guiderList: [],
      guiderCurrentPage: 1,
      guiderPageSize: 10,
      guiderListTotal: 0,
      declareTime: [],
      dialogVisible: false,
      dialogVisibleRefuse: false,
      ruleForm: {
        refuseReason: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  moutned() {
    this.queryList();
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    reject(row) {
      this.dialogVisibleRefuse = true;
      this.rows = row;
    },
    consent(row) {
      // let params = {
      //   operationType: "agree",
      //   getcashId: row.getcashId
      // };
      // this.shareGetcashOrder(params).then(res => {
      //   if (res.code === "0") {
      //     this.$message({
      //       type: "success",
      //       message: "操作成功！"
      //     });
      //     this.queryList();
      //     this.queryTotal();
      //   }
      // });
    },
    switchTabs() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        auditState: this.auditState
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      //   const { result } = await this.$store.dispatch("queryCashOutList", params);
      //   this.result = result;
      //   this.list = result.records;
      //   this.total = result.total;
    },
    async queryGuiderOrderList(row) {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: row.guiderId,
        auditState: "agree",
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length ? this.declareTime[1] : ""
      });
      const { records, total } = result;
      this.guiderList = records;
      this.guiderListTotal = total;
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList(this.row);
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList(this.row);
    },
    bill(row) {
      this.type = "daoGou";
      this.title = "个人账单";
      this.dialogVisible = true;
    },
    toAdd() {
      this.type = "shop";
      this.title = "门店提现申请";
      this.dialogVisible = true;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    searchMember() {
      this.queryMemberList();
    },
    async queryMemberList() {
      let params = {
        pageSize: 100,
        pageNo: 1,
        queryType: this.queryType,
        keyword: this.keyWord
      };
      const { result } = await this.$store.dispatch(
        "queryMemberMgtList",
        params
      );
      this.memberInfo = result.records;
    },
    remove(i) {
      this.addAgentList.splice(i, 1);
    },
    confirmAdd(v) {
      let flag = true;

      this.addAgentList.map(item => {
        if (v.centerId === item.centerId) {
          flag = false;
        }
      });

      if (flag) {
        let params = {
          centerId: v.centerId,
          agentPhone: v.memberMobile,
          agentName: v.memberName,
          sourceType: v.sourceType,
          storeCode: v.storeCode,
          actualRewardRatio: ""
        };
        this.addAgentList.push(params);
      }
    },
    filterGt0OrFixed222(prop, i) {
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addAgentList[i][prop] = this.addAgentList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addAgentList[i][prop].indexOf(".") < 0 &&
        this.addAgentList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addAgentList[i][prop] = parseFloat(this.addAgentList[i][prop]);
      }
    },
    async save() {
      if (this.addAgentList.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选择代理人"
        });
      } else {
        let show = false;
        let beyond = false;
        this.addAgentList.map(v => {
          if (!v.agentTitleId || !v.actualRewardRatio) {
            show = true;
          } else {
            if (v.actualRewardRatio > 100) {
              beyond = true;
            }
          }
        });
        if (show) {
          this.$message({
            type: "warning",
            message: "请先选择代理头衔或者填写实际比例！"
          });
        } else {
          if (beyond) {
            this.$message({
              type: "warning",
              message: "实际奖励比例不能超过100！"
            });
          } else {
            // const { code } = await this.$store.dispatch(
            //   "addShareAgent",
            //   addAgentList
            // );
            // if (code === "0") {
            //   this.$message({
            //     type: "success",
            //     message: "操作成功"
            //   });
            //     this.rest();
            //   this.dialogVisible = false;
            //   this.queryList();
            // }
          }
        }
      }
    },
    rest() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.row = {};
        this.addAgentList = [];
        this.keyWord = "";
        this.memberInfo = [];
      }, 0);
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res;
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    submitReject(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.auditState = "refuse";
          const searchCondition = JSON.parse(JSON.stringify(this.ruleForm));
          const params = JSON.parse(JSON.stringify(this.rows));

          Object.assign(params, searchCondition);

          this.$store.dispatch("opertaeCashOutList", params).then(res => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.$message({
                message: "操作成功!",
                type: "success"
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.queryList();
            } else {
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.agent {
  font-family: PingFang SC;
  font-weight: 500;
  // font-size: 14px;
  // height: 32px;
  color: #222;
}
.member-body {
  width: 300px;
  padding: 5px 0;
}
</style>
